module.exports = __webpack_public_path__ + "2023630/img/loginbg.0e6e1253.jpg";